module.exports = __webpack_public_path__ + "static/media/img_1.1ed43971.JPG";